module.exports = __webpack_public_path__ + "static/media/dry.baae2d8b.jpg";